<template>
  <div class="login-form">
    <p class="verify-account-title">Verify your account</p>
    <p class="verify-account-text">{{ status }}</p>
  </div>
</template>

<script>
export default {
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const id = urlParams.get('id')
    
    var response_json = await this.verify(code, id)
    if (response_json.status === "fail") {
      this.success = false;
      this.status = response_json.message
    } else {
      this.success = true;
      this.status = 'Your account is now verified'
    }
  },
  data(){
    return {
      success: false,
      status: ''
    }
  },
  methods: {
    async verify(code, id) {
      const requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };
      return await fetch(`https://oauth${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : '-stage'}.fanscore.com/users/${id}/verify?code=${code}`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data
        })
        .catch(error => {
          console.log('error', error)
        });
    }
  }
}
</script>

<style>
.verify-account-text {
  text-align: left;
}
</style>